import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { ParcellaGiudizialeForm } from '../../../form/parcelle/giudiziali/parcella-giudiziale-form';


import { SezioneParcelleGiudizialiResponse } from '../../../models/dto/sezione-parcelle-giudiziali-response';
import { ParcellaGiudiziale } from '../../../models/parcella-giudiziale';

import { SezioneParcelleGiudiziali } from '../../../models/sezioni/sezione-parcelle-giudiziali';

@Component({
    selector: 'div [parcella-giudiziale-form-edit]',
  templateUrl: '../../../form/parcelle/giudiziali/parcella-giudiziale-form.html'
})

export class ParcelleGiudizialiEditComponent extends ParcellaGiudizialeForm {
  parcellaGiudiziale: ParcellaGiudiziale;
  sezione: SezioneParcelleGiudiziali;
  urlUpdate: string;
  urlReadSezioneLegali: string;
  urlReadSezioneEconomica: string;
  urlGetScaglioni: string;
  tipoFascicolo: any;
  tipoPratica: any;

  @Output() onReturn: EventEmitter<SezioneParcelleGiudiziali> = new EventEmitter<SezioneParcelleGiudiziali>();

  constructor(@Inject(OperationsService) operationService, @Inject(FormBuilder) campiForm, @Inject(HelpersService) helpers: HelpersService) {
        super(operationService, campiForm, helpers);
  }

  ngOnInit() {
    this.setTitle('Modifica Parcella');
    this.isInserimento(false);
  }

  getParcellaGiudiziale() {
    return this.parcellaGiudiziale;
  }

  getUrlReadSezioneLegali() {
    return this.urlReadSezioneLegali;
  }

  getUrlReadSezioneEconomica() {
    return this.urlReadSezioneEconomica;
  }

  getUrlGetScaglioni() {
    return this.urlGetScaglioni;
  }

  getTipoFascicolo(): any {
    return this.tipoFascicolo;
  }

  getTipoPratica(): any {
    return this.tipoPratica;
  }

  getIdFascicolo() {
    return this.sezione.idParent;
  }

  getRequest(request: ParcellaGiudiziale) {
    this.operationService.updateParcellaGiudiziale(this.urlUpdate, request, this.sezione.id).subscribe((response: any) => this.datiParcellaGiudiziale(response));
  }

  datiParcellaGiudiziale(response: SezioneParcelleGiudizialiResponse) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }

  inizializza(sezione: SezioneParcelleGiudiziali,
              parcellaGiudiziale: ParcellaGiudiziale,
              idSezioneLegali: string,
              idSezioneEconomica: string,
              urlUpdate: string,
              urlReadSezioneLegali: string,
              urlReadSezioneEconomica: string,
              urlGetScaglioni: string,
              tipoFascicolo: any,
              tipoPratica: number) {
    this.parcellaGiudiziale = parcellaGiudiziale;
    this.sezione = sezione;
    this.urlUpdate = urlUpdate;
    this.urlReadSezioneLegali = urlReadSezioneLegali;
    this.urlReadSezioneEconomica = urlReadSezioneEconomica;
    this.urlGetScaglioni = urlGetScaglioni;
    this.tipoPratica = tipoPratica;
    this.tipoFascicolo = tipoFascicolo;
    if (idSezioneLegali) {
      this.readSezioneLegali(idSezioneLegali);
    }
    if (idSezioneEconomica) {
      this.readSezioneEconomica(idSezioneEconomica);
    }
    this.createForm();
    this.populateSelect();
  }

}
